module.exports = __webpack_public_path__ + "static/media/car3.ca0216c8.jpg";